import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=fb9782a6&"
import script from "./translate.ts?vue&type=script&lang=js&"
export * from "./translate.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports